import React from 'react'
import Logo from '../../components/Logo'
import DateTime from '../../components/DateTime'
import { connect } from 'react-redux';
import Logout from '../../components/Logout';

const TitleBar = props => (
      <div id="titlebar">
        <Logo />
        <div className="titlebar-buttoncontainer"></div>
        <div className="titlebar-right">
          <div className="titlebar-datetime">
            <DateTime />
          </div>
          <div className="titlebar-info">
            <i className="user icon">&nbsp;</i>
            {props.user.username}
          </div>
        </div>
        <Logout/>
      </div>
    )

function mapStateToProps(state) {
  return {
    user: state.loginState.loggedin
  }
}

export default connect(mapStateToProps)(TitleBar)



// WEBPACK FOOTER //
// src/ticket/components/TitleBar.jsx